import { render, staticRenderFns } from "./training-pro-overview.vue?vue&type=template&id=031879de&scoped=true&"
import script from "./training-pro-overview.vue?vue&type=script&lang=js&"
export * from "./training-pro-overview.vue?vue&type=script&lang=js&"
import style0 from "./training-pro-overview.vue?vue&type=style&index=0&id=031879de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "031879de",
  null
  
)

export default component.exports